// extracted by mini-css-extract-plugin
export default {"container":"RiskRegisterTabs_container__JWjyH"};